<!-- Skeleton.svelte -->
<script>
	export let width = '90%';
	export let height = '50px';
	export let borderRadius = '8px';
	//export let animation = 'pulse';
</script>

<div class="skeleton" style="width: {width}; height: {height}; border-radius: {borderRadius};" />

<style>
	.skeleton {
		background: linear-gradient(90deg, #f0f0f0, #e0e0e0, #f0f0f0);
		background-size: 200% 100%;
		animation: pulse 1.5s infinite;
		margin: 5px auto;
		position: relative;
		overflow: hidden;
	}

	@keyframes pulse {
		0% {
			background-position: 100% 0;
		}
		100% {
			background-position: -100% 0;
		}
	}

	@keyframes shimmer {
		0% {
			background-position: -100% 0;
		}
		100% {
			background-position: 100% 0;
		}
	}

	@keyframes wave {
		0% {
			transform: translateX(-100%);
		}
		100% {
			transform: translateX(100%);
		}
	}
</style>
